import { useQuery } from "react-query";



/**
Query constants for keys to identify the cache
*/


export const NAMESPACE_ROLES_PERMISSIONS = 'namespace:roles:permissions';
export const NAMESPACE_DOCUMENT_ACCESS_CONTROLS = 'namespace:document_access_controls';
export const NAMESPACE_PERMISSIONS_LOAN_PRODUCTS = 'namespace:permissions:loan_products';
export const NAMESPACE_BRANCHES = 'namespace:branches';
export const APPLICANT_INITIAL_LOAN_APPLICATION = 'applicant_initial_loan_application';
export const APPLICANT_CO_LOAN_APPLICATION = 'applicant_co_loan_application';
export const NAMESPACE_LOAN_PRODUCTS = 'namespace:loan_products';
export const LOAN_PERMISSIONS_AND_ACTIVITY = 'loan_permissions:loan_system_activities';
export const ACCOUNT_ROLE_ID = 'accounts:role_id';
export const GLOBAL_PERMISSION_TEMPLATES = 'global:permission_templates'
export const GLOBAL_FEATURES = 'global:features'
export const USER_POD_CONFIGS = 'user:pod_configs'
export const USER_TEAMS = 'user:teams'
export const NAMESPACE_TEAMS = 'namespace:teams'
export const MORTGAGE_RATES = 'mortgage:rates';
export const GLOBAL_NAMESPACE_VARMAPS = 'global:namespace:varmaps'

export const AUTHENTICATED_USER_PERMISSIONS = 'authenticated:user_roles:permissions';
export const AUTHENTICATED_USER_DOCUMENT_ACCESS_CONTROLS = 'authenticated:user_roles:document_access_controls';
export const AUTHENTICATED_USER_DOCUMENT_ARTIFACTS_MINIMAL = 'authenticated:user_roles:document_artifacts:minimal';

export const AUTHENTICATED_USERS_LOANAPPS = 'authenticated:user:loanapps';


/**
useReactQuery used to from react query
@param queryKey { array } identifier key and identifier id or object
   recommented second argument of key should be id (like loanId if its related loan query)
@param queryFn { promise function } function that execute promise and return data to maintain cache
@param queryOptions { object } react query options
*/
export const useReactQuery = (
    queryKey: [string, any],
    queryFn: () => Promise<any>,
    queryOptions: any,
) => {
    return useQuery<any, any>(
        queryKey,
        queryFn,
        queryOptions);
};